/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'api-product-data-change';

let _store = {
    products        : [],
    activeProduct   : null,
    lastFailure     : null
};

class ProductStoreClass extends EventEmitter {
    constructor() {
        super();
        console.log("[Product Store] - initialisation");
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    productForId(productId) {
        if (!_store.products) {
            return null;
        }

        for (var ix = 0 ; ix < _store.products.length; ix++) {
            var p = _store.products[ix];
            if (p.productId === productId) {
                return p;
            }
        }

        return null;
    }

    products() {
        return _store.products ;
    }

    currentProduct() {
        return _store.activeProduct ;
    }

    lastFailure() {
        return _store.lastFailure ;
    }
}

const ProductStore = new ProductStoreClass();

AppDispatcher.register((payload) => {
  const action = payload.action;
 
  switch (action.actionType) {
    case AppConstants.PRODUCT_SET_LOAD: 
        console.log("[ProductStore] - loaded ", action.result);
        _store.products = action.result;
        ProductStore.emit(CHANGE_EVENT,AppConstants.PRODUCT_SET_LOAD);
        break ;

    case AppConstants.PRODUCT_LOAD: 
        _store.activeProduct = action.result ;
        ProductStore.emit(CHANGE_EVENT,AppConstants.PRODUCT_LOAD);
        break ;

    case AppConstants.PRODUCT_SAVE: 
        ProductStore.emit(CHANGE_EVENT,AppConstants.PRODUCT_SAVE);
        break ;

    case AppConstants.PRODUCT_SET_LOAD_ERR: 
        _store.lastFailure = action.error ;
        ProductStore.emit(CHANGE_EVENT,AppConstants.PRODUCT_SET_LOAD_ERR);
        break ;

    case AppConstants.PRODUCT_LOAD_ERR: 
        _store.lastFailure = action.error ;
        ProductStore.emit(CHANGE_EVENT,AppConstants.PRODUCT_LOAD_ERR);
        break ;

    case AppConstants.PRODUCT_SAVE_ERR: 
        _store.lastFailure = action.error  ;
        ProductStore.emit(CHANGE_EVENT,AppConstants.PRODUCT_SAVE_ERR);
        break ;

    default:
        return true;
  }
});

export default ProductStore;




// WEBPACK FOOTER //
// ./src/app/stores/ProductStore.js